import { Action, combineReducers, Reducer } from 'redux';
import reduceReducers from 'reduce-reducers';

import { RootState } from '@/core/interfaces/store';
import config from '@/core/store/reducers/config';
import hydrateSlice from '@/core/store/reducers/hydrate';
import filters from '@/core/store/reducers/filtersSlice';
import modalStack from '@/core/store/reducers/modalStackSlice';

import auth from '@/features/Auth/store/slices';
import geofeatures from '@/features/Geofeatures/store/slices';
import reports from '@/features/Reports/store/slices';
import riskAssessment from '@/features/RiskAssessment/store/slices';
import focuses from '@/features/Focus/store/slices';
import analyses from '@/features/ChatBot/store/slices';
import analytics from '@/features/Analytics/store/slices';
import userPreferences from '@/features/UserPreferences/store/slice';

const featuresReducer = combineReducers({
  auth,
  userPreferences,
  config,
  reports,
  geofeatures,
  filters,
  modalStack,
  riskAssessment,
  focuses,
  analyses,
  analytics,
});

export const rootReducer = reduceReducers<RootState>(hydrateSlice, featuresReducer) as Reducer<
  RootState,
  Action
>;
